const validateNaf = (id: string): boolean => {
  const NAF_REGEX = /^(\d{2})\/?(\d{8})\/?(\d{2})$/

  if (!id || id.length === 0) {
    return false
  }

  const result = id.match(NAF_REGEX)

  if (!result) {
    return false
  }

  const province = result[1]
  const account = result[2]
  const control = result[3]

  const pad_account = account?.charAt(0) === '0' ? account?.slice(1) : account

  return parseInt(`${province}${pad_account}`) % 97 === parseInt(control as string)
}

export default validateNaf
